import { useUser } from "hooks"

export default function Scope({ role, children }){

    const { data } = useUser()

    if(data?.roles?.includes(role) || data?.roles?.includes('*')) return children

    return <></>
}